export const API_ROOT: string = "https://api.preprod-virtual.laplateforme.io"
export const MERCURE_HUB: string = "https://mercure.preprod-virtual.laplateforme.io"
export const GOOGLE_CLIENT_ID: string = "861689442005-tucckl6biau5cd20fa5pbe4i465jgrta.apps.googleusercontent.com"
export const GOOGLE_HOSTED_DOMAIN: string = "laplateforme.io"
export const ENV_NAME: string = "prod"
export const JITSI_APP_ID: string = "vpaas-magic-cookie-593da3fb3eae4b39b0f31c44835c62fe"
